import { useContext } from 'react';
import TrackWrapper from '@/common/TrackWrapper';
import { contentWithNavStyles, TileGrid } from '@/new-cars/new-cars.styles';
import ModelVersionCard from '~/components/new-cars/ModelVersionSection/ModelVersionCard';
import SectionName from '~/constants/new-cars/SectionName';
import { SECTION_VIEW_THRESHOLD } from '~/constants/new-cars/sectionViewThreshold';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

const viewEvent = {
  customAttributes: {
    action: 'viewed',
    level: 'Model Version',
    section: 'Model Version'
  },
  eventName: 'New Cars'
};

type OwnProps = {
  heading?: string;
};

function ModelVersionSection({ heading }: OwnProps) {
  const { modelVersions, selectedModelVersion, selectedParentModel } =
    useContext(ParentModelContext);

  const { parentModel } = selectedParentModel;
  const displayHeading =
    heading ?? (parentModel ? `Select a ${parentModel}` : 'Select a Model');

  return (
    <TrackWrapper
      aria-labelledby="model-version-section-heading"
      element="section"
      event={viewEvent}
      threshold={SECTION_VIEW_THRESHOLD}
      trackOnce
      className={contentWithNavStyles}
    >
      <h2
        className="text-text-strong t-heading-xl"
        id="model-version-section-heading"
      >
        {displayHeading}
      </h2>
      <TileGrid withNav>
        {modelVersions.data.results.map(modelVersion => (
          <ModelVersionCard
            key={modelVersion.title}
            modelVersion={modelVersion}
            selected={
              selectedModelVersion?.modelVersion ===
              modelVersion.next.modelVersion
            }
          />
        ))}
      </TileGrid>
    </TrackWrapper>
  );
}

export default withErrorBoundary<OwnProps>(
  ModelVersionSection,
  undefined,
  undefined,
  SectionName.ModelVersion
);
